<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right"
                    :hidden="btnAggiungi" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <template v-if="items.length > 0">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(createDate)="{ item }">
                            <span>{{ formatDateTime(item.createDate) }}</span>
                        </template>
                        <template v-slot:cell(pri)="{ item }">
                            <span style="font-style: italic; font-weight: 600;">{{ item.idPri == null ?
                                'Codice PRI non censito' :
                                item.idPri }}</span>
                        </template>
                        <template #cell(action)="{ item }">
                            <!-- <b-button size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onUpdatePostiLetto(row.item)">
                            <i class="fas fa-bed"></i>
                        </b-button> -->
                            <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary"
                                @click="onViewPri(item)" title="Visualizza">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <!-- <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-danger"
                                @click="onClickDeleteScala(item)" title="Elimina">
                                <font-awesome-icon icon="trash" />
                            </b-button> -->
                        </template>
                    </b-table>
                </template>
                <template v-else>
                    <NoDataComponent ref="cmpNoDataComponent"
                        title="Non sono presenti Progetti Riabilitativi Individuali per il paziente" nome="no-data"
                        subtitle="" icon="fas fa-users" />
                </template>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <b-modal title="Crea/Modifica P.R.I" centered scrollable footer-tag="footer" @shown="onShownModalPriEdit"
            no-close-on-backdrop no-close-on-esc hide-header-close ref="mdlPriEditModal" id="mdlPriEditModal" size="xl"
            style="height: 100%;">
            <ProgettoRiabilitativoIndividualeEditComponent ref="mdlPriEditComponent" @afterSave="onAfterSave" />
            <template #modal-footer>
                <div class="d-flex justify-content-end w-100">
                    <b-button size="sm" variant="danger" class="ml-2" @click="onAnnulla()"> Annulla</b-button>
                    <b-button size="sm" variant="success" class="ml-2" @click="onSalvaProgettoRiabilitativo()">Salva
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import ProgettoRiabilitativoIndividualeEditComponent from "./ProgettoRiabilitativoIndividualeEditComponent.vue"
import NoDataComponent from "../../../../template/components/utility/NoDataComponent.vue";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { ProgettoRiabilitativoIndividualeEditComponent, NoDataComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/progettoriabilitativoindividuale",
            btnAggiungi: false,
            priFilter: { idAccettazione: null },
            idAccettazione: "",
            isView: false,
            priSelezionato: {},
            jsonData: {},
            items: [],
            fields: [
                {
                    label: "Pri",
                    key: "pri",
                    sortable: true,
                    thStyle: "width: 14rem",
                },
                {
                    label: "Data/Ora Compilazione",
                    key: "createDate",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Autore",
                    key: "createUser",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "",
                    key: "action",
                    thStyle: "width: 7rem",
                    tdClass: "text-center",
                },
            ],
        };
    },
    methods: {
        init(jsonData) {
            this.idAccettazione = jsonData.id;
            this.priFilter.idAccettazione = jsonData.id;
            this.jsonData = jsonData;
            this.loadData();
        },
        loadData() {
            let me = this;
            this.loadDataResources(me.pathResource, me.priFilter, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.log(error);
            me.$emit("afterLoadData");
        },
        onClickAggiungi() {
            this.openModalPriEdit();

        },
        onViewPri(item) {
            this.$refs.mdlPriEditModal.show();
            this.isView = true;
            this.priSelezionato = item;
        },
        openModalPriEdit() {
            this.$refs.mdlPriEditModal.show();
        },
        hideModalPriEdit() {
            this.$refs.mdlPriEditModal.hide();
        },
        onShownModalPriEdit() {
            if (!this.isView) {
                this.$refs.mdlPriEditComponent.init(this.jsonData);
            } else {
                this.$refs.mdlPriEditComponent.setViewPri(this.priSelezionato, this.jsonData);
            }

        },
        onClickVisualizzaScala(item) {
            let me = this;
            me.$refs.mdlPriEditModal.visualizzaScala(item);
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },


        onAnnulla() {
            this.isView = false;
            this.hideModalPriEdit();

        },
        onSalvaProgettoRiabilitativo() {
            this.openShowModalLoading()
            let jsonToSave = this.$refs.mdlPriEditComponent.getJsonData();
            delete jsonToSave.sesso;
            delete jsonToSave.eta;
            delete jsonToSave.domicilio;
            delete jsonToSave.residenza;
            delete jsonToSave.dataNascita;
            delete jsonToSave.provenienza;
            let link = process.env.VUE_APP_PATH_API + "/progettoriabilitativoindividuale";
            if (this.isView) {
                axios.put(link + "/" + jsonToSave.id, jsonToSave).then((response) => {
                    response;
                    toast.success("Modificato con successo");
                    this.$refs.mdlPriEditModal.hide();
                    this.closeShowModalLoading();
                    this.loadData();
                }).catch((err) => {
                    this.closeShowModalLoading();
                    toast.error(err.response.data.messaggio)
                });
            } else {
                axios.post(link, jsonToSave).then((response) => {
                    response;
                    toast.success("salvato con successo");
                    this.$refs.mdlPriEditModal.hide();
                    this.closeShowModalLoading();
                    this.loadData();
                }).catch((err) => {
                    this.closeShowModalLoading();
                    toast.error(err.response.data.messaggio)
                });
            }
        }
    },
};
</script>

<style></style>
